import camelcaseKeys from 'camelcase-keys';
import z from 'zod';

const ApplicationHotOfferSchema = z
  .object({
    id: z.number(),
    name: z.string().nullable(),
    offer: z.string().nullable(),
    how_to_get: z.string().nullable(),
    start_date: z.number().nullable(),
    end_date: z.number().nullable(),
    icon: z.string().nullable(),
    banner: z.string().nullable(),
    banner_16_9: z.string().nullable(),
    page_back_image: z.string().nullable(),
    index: z.number(),
    deleted: z.boolean(),
    seo_title: z.string(),
    seo_description: z.string(),
    seo_keywords: z.string().nullable(),
    offer_amount: z.string().nullable(),
    offer_type: z.string(),
    offer_id: z.string(),
    offer_price: z.any().nullable(),
    offer_currency: z.string().nullable(),
    face_currency: z.any().nullable(),
    lock_period: z.any().nullable(),
    cashback_percentage: z.any().nullable(),
    pool_amount: z.any().nullable(),
    cashback_description: z.any().nullable(),
    claim_karma_threshold: z.number(),
    app_id: z.number().nullable(),
    payout_token_ids: z.any().nullable(),
    payout_tokens: z.array(z.record(z.string(), z.any())).nullable(),
    claims_limit: z.number().nullable(),
    claims_per_user_limit: z.any().nullable(),
    developer_id: z.any().nullable(),
    offer_params: z.record(z.string(), z.any()).nullable(),
    priority_access: z.boolean().nullable(),
    min_membership_tier: z.string().nullable(),
    meta_robots: z.boolean().nullable(),
    last_notification_sent_at: z.any().nullable(),
    offer_category: z.string().nullable(),
    magic_wall: z.boolean().nullable(),
    category_ids: z.any().nullable(),
    karma_reward: z.any().nullable(),
    token_reward_disabled: z.any().nullable(),
    hidden: z.boolean(),
    reward_pool_id: z.any().nullable(),
    paused: z.string().nullable(),
    is_claimed: z.boolean().nullable(),
    claim_counter: z.number().nullable(),
    activePayoutToken: z.record(z.string(), z.any()).nullable(),
  })
  .transform((value) => camelcaseKeys(value, { deep: true }));

export type ApplicationHotOfferSchemaPayload = z.infer<typeof ApplicationHotOfferSchema>;

const ApplicationFarmPoolSchema = z
  .object({
    id: z.string(),
    chain: z.number().nullable(),
    index: z.number().nullable(),
    address: z.string().nullable(),
    label: z.string().nullable(),
    start_date: z.string().nullable(),
    end_date: z.string().nullable(),
    symbol: z.string().nullable(),
    start_reward: z.number().nullable(),
    start_apr: z.number().nullable(),
    staked: z.number().nullable(),
    participants: z.number().nullable(),
    app_id: z.number().nullable(),
    hidden: z.boolean().nullable(),
    created_at: z.string().nullable(),
    updated_at: z.string().nullable(),
    logo_url: z.string().nullable(),
    token_address: z.string().nullable(),
    seo: z.record(z.string(), z.any()),
    external_link: z.string().nullable(),
    boost_type: z.string(),
    participants_registered: z.number(),
    settings: z.record(z.string(), z.any()),
  })
  .transform((value) => camelcaseKeys(value, { deep: true }));

export type ApplicationFarmPoolSchemaPayload = z.infer<typeof ApplicationFarmPoolSchema>;

export const ApplicationActivitiesPayloadSchema = z.object({
  hotOffers: ApplicationHotOfferSchema.array(),
  farmPools: ApplicationFarmPoolSchema.array(),
  rewardPools: z.array(z.any()),
});

export type ApplicationActivitiesPayload = z.infer<typeof ApplicationActivitiesPayloadSchema>;
